import { getStore } from '../../../helpers/initStore.js';
import { getCollectionFailure } from './helpers/collection.js';
import { getTimeSlotDebugInfo } from './helpers/utilities.js';
import { getIsDebugMode } from '../../variables/helpers.js';

/** Filters time slots based on collection medical restrictions */
const getCollectionFilteredTimeSlots = (timeSlots) => {
    const store = getStore();
    const isDebugMode = getIsDebugMode();
    const timeSlotsByDateObject = {};
    const collectionDate = store.getters['schedulingFlow/getProcedureCollectionDate'];
    const collectionTime = store.getters['schedulingFlow/getProcedureCollectionTime'];
    const collectOn = store.getters['schedulingFlow/getProcedureCollectOnDate'];
    const collectEnd = store.getters['schedulingFlow/getProcedureCollectEndDate'];
    Object.entries(timeSlots).forEach(([date, timeSlotsByTime]) => {
        Object.entries(timeSlotsByTime).forEach(([time, timeSlot]) => {
            var _a;
            const collectionFailure = getCollectionFailure(timeSlot.startTime, collectionDate, collectionTime, collectOn, collectEnd);
            const timeSlotsForTime = (_a = timeSlotsByDateObject[date]) !== null && _a !== void 0 ? _a : {};
            if (!collectionFailure)
                timeSlotsForTime[time] = timeSlot;
            if (collectionFailure && isDebugMode) {
                timeSlotsForTime[time] = getTimeSlotDebugInfo(timeSlot, [collectionFailure]);
            }
            timeSlotsByDateObject[date] = timeSlotsForTime;
        });
    });
    return timeSlotsByDateObject;
};

export { getCollectionFilteredTimeSlots };
